import { AbstractCollection } from '../../abstract/Collection';
import { AbstractDocument, Identifiable, Timestampable } from '../../abstract/Document';
import { type Wedding, Weddings } from '../Weddings';
import type { IAgent } from './Agents.types';
import { Actions } from './Agents/Actions';
import { Conversations } from './Agents/Conversations';
import { Memories } from './Agents/Memories';
import { Schedules } from './Agents/Schedules';
import { Skills } from './Agents/Skills';

@Identifiable
@Timestampable
export class Agent extends AbstractDocument<IAgent> {
  readonly collections = {
    Actions: new Actions(this),
    Conversations: new Conversations(this),
    Memories: new Memories(this),
    Schedules: new Schedules(this),
    Skills: new Skills(this),
  };

  get wedding() {
    return Weddings._.getById(this.ids.weddings);
  }
}

export class Agents extends AbstractCollection<Agent, IAgent> {
  static path = 'agents';

  /** The default planning agent — one per wedding, under a well-known id. */
  static PLANNER = '00000000-0000-4000-8000-000000000000' as const;

  constructor(document: Wedding) {
    super(document.collection(Agents.path), Agent);
  }

  get wedding() {
    return Weddings._.getById(this.ids.weddings);
  }
}
